<template>
    <div>
        <MainmenuItem :menuTitle="lbl.main.menubar.home" :active="isActiveMenu('home')" url="/home">
            <img v-if="isActiveMenu('home')" class="h-25px" src="../../../../../assets/menu_icon/ic-Home.svg">
            <img v-else class="h-25px" src="../../../../../assets/menu_icon/ic-Home-inactive.svg">
        </MainmenuItem>
        <MainmenuItem :menuTitle="lbl.main.menubar.reward" :active="isActiveMenu('reward')" url="/reward">
            <img v-if="isActiveMenu('reward')" class="h-25px" src="../../../../../assets/menu_icon/ic-Rewards-active.svg">
            <img v-else class="h-25px" src="../../../../../assets/menu_icon/ic-Rewards.svg">
        </MainmenuItem>
        <MainmenuItem :menuTitle="lbl.main.menubar.earn_point" :active="isActiveMenu('EarnPoint')" :url="earnUrl">
            <img v-if="isActiveMenu('EarnPoint')" class="h-25px" src="../../../../../assets/menu_icon/ic-earn-active.svg">
            <img v-else class="h-25px" src="../../../../../assets/menu_icon/ic-earn.svg">
        </MainmenuItem>
        <MainmenuItem :menuTitle="lbl.main.menubar.my_order" :active="isActiveMenu('MyOrder')" url="/myorder">
            <img v-if="isActiveMenu('MyOrder')" class="h-25px" src="../../../../../assets/menu_icon/ic-order-active.svg">
            <img v-else class="h-25px" src="../../../../../assets/menu_icon/ic-Tracking.svg">
        </MainmenuItem>
        <MainmenuItem :menuTitle="lbl.main.menubar.catering" :active="isActiveMenu('Info')" url="/info/catering">
            <img v-if="isActiveMenu('Info')" class="h-25px" src="../../../../../assets/profile_icon/catering-active.svg">
            <img v-else class="h-25px" src="../../../../../assets/profile_icon/catering.svg">
        </MainmenuItem>
    </div>
</template>

<script>
import MainmenuItem from './MainmenuItem.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
export default {
    mixins: [LocaleMixin,AuthStatusMixin],
    components: {
        MainmenuItem
    },
    data: function() {
        return {
            earnUrl: '/earnpoint',
        };
    },
    methods: {
        onAccountInit: function () {
            if (this.isLoginGuest) {
                let path = this.$route.path;
                console.log(path)
                this.earnUrl = '/login?afterLogin=' + path;
            }
        },
        isActiveMenu: function (menu) {
            let currentPage = this.$route.name;
            return currentPage == menu;
        },
    }
}
</script>

<style>

</style>
